import { render, staticRenderFns } from "./Solicitud_piezas.vue?vue&type=template&id=4d39fd08&"
import script from "./Solicitud_piezas.vue?vue&type=script&lang=js&"
export * from "./Solicitud_piezas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports